import React, {useContext} from "react";
import CredentialsContext from "../contexts/CredentialsContext";
import { Link } from "react-router-dom";
import $ from "jquery";

/* import StateDescriptionPanel from "./../../Debugging/components/StateDescriptionPanel"; */
import "../css/comment-list.css";

import getAllCssRules from '../../js/utils/getAllCssRules';
import { saveAs } from '../../js/utils/FileSaver';
import CommentForm from "./CommentForm";

export default function CommentInfo({ comment }) {

  //TODO: абстрагировать
  async function saveToHtml(){
   /*  const $ = window.jQuery */

    const root = $('<div>').append($("body").clone())
    $('a', root).remove();
    $('.header-main', root).remove();
    
    $("*", root).each(function(){
      if (this.tagName.toLowerCase() === 'script') return
      $(this).css(getAllCssRules($(this), $))
      if (this.tagName.toLowerCase() === 'body') 
        $(this).css({"max-width": "1170", "margin": "0 auto"})
      $(this).removeAttr('class');
    })
    const content = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8" />
          <title>Document</title>
      </head>
        ${root.html()}
      </html>  
    `

    const blob = new Blob([ content ], {type: "text/plain;charset=utf-8"})
    saveAs(blob, `Комментарий#${comment.id}.html`);
  }
  //END TODO

  const {credentials} = useContext(CredentialsContext);
  let gameName = comment.game_id !== undefined ? credentials.games[comment.game_id]?.name : "не указана";

  return (
    <div>
      <div className="comment-short-info-wrapper row">
        <div className="col-md-2">
          <Link to ="/comments">К списку комментариев</Link>
        </div>
        <div className="col-md-2">
          <a href='#' onClick={()=>saveToHtml()}>Сохранить комментарий</a>
        </div>

        {/* <div className="col-md-12">
          <CommentShortInfo comment = {comment}/>
        </div> */}
        <div className="comment-head">
          <div>Игра: «{gameName}»</div>
          <div>Автор: {comment.username}</div>
          <div>Дата и время создания: {comment.datetime} (UTC+3)</div>
          <div></div>
        </div>
        

        {<div className="col-md-12">
          <CommentForm commentInfo = {comment}/>
        </div>}
      
      </div>
      <hr />
      {/* <div className="comment-state-description-panel">
        <StateDescriptionPanel state={comment.state} mode={1} >
        </StateDescriptionPanel>
      </div> */}
    </div>
  )
}